<template>
  <div id="imageContainer" class="activity-wide" data-activity-asset>
    <AssetImage
      :id="data[0].id"
      ref="image"
      :controls="showControls"
      bg-color="white"
      :disable-resize-events="true"
      :src="
        isOnline ? data[0].value : findPreloadedAsset('image', data[0].value)
      "
      @loaded="positionHotspots"
      @on-fullscreen-toggle="$emit('on-fullscreen-toggle', $event)"
    />
  </div>
</template>

<style lang="scss" scoped>
.activity-wide {
  position: relative;
  background-color: transparent;
  margin: auto;
  width: auto;
  height: auto;
  @media (min-width: #{$tablet}px) {
    border: $activityMediaBorderSize solid white;
    border-radius: 22px;
  }
}
</style>

<script lang="ts">
import { Component, Prop, Ref, Watch, Vue } from 'vue-property-decorator';

import AssetImage from '@/components/Asset/Image.vue';
import EventBus from '@/utils/helpers/EventBus';
import { IActivityComponentData } from '@/models/interfaces/activities';
import { Getter } from 'vuex-class';
import { PreloadedAssetType } from '@/store/modules/preload-assets';

@Component({
  components: {
    AssetImage,
  },
})

/**
 * Wide-screen image activity component
 * Replaces the ActivityImage component to make full use of desktop screen width
 */
export default class ActivityWsImage extends Vue {
  @Prop({ required: true })
  private data!: IActivityComponentData;

  @Prop({ default: false, type: Boolean })
  private isCarouselItem!: boolean;

  @Prop({ default: 1 })
  private animDuration!: number;

  @Prop({ default: 0.4 })
  private animDelay!: number;

  @Ref('image')
  private image!: Vue;

  @Getter('preloadAssets/findPreloadedAsset')
  private findPreloadedAsset!: (
    type: PreloadedAssetType,
    originalUrl: string,
  ) => string;

  private showControls = true;

  private positionHotspots() {
    const imageContainer = document.getElementById('imageContainer');
    if (!imageContainer) {
      return;
    }

    let { width, height } = this.image.$el.getBoundingClientRect();

    const containerStyle = window.getComputedStyle(imageContainer);
    const left =
      imageContainer.offsetLeft + parseInt(containerStyle.borderLeftWidth, 10);
    const top =
      imageContainer.offsetTop + parseInt(containerStyle.borderTopWidth, 10);

    const positioningData = {
      left,
      width,
      height,
      top: top, //Math.max(top - 80, 0), // Fudge factor
      position: 'absolute',
    };

    EventBus.$emit('set-assets-hotspots-container-positioning', {
      ...positioningData,
      controls: true,
    });
  }

  public mounted() {
    EventBus.$on('activity-event-hide-fullscreen', () => {
      this.showControls = false;
    });
  }

  public beforeDestroy() {
    EventBus.$off('activity-event-hide-fullscreen');
  }

  @Watch('windowWidth')
  private onResize() {
    this.$nextTick(() => {
      this.positionHotspots();
    });
  }

  @Watch('windowHeight')
  private onResizeHeight() {
    this.$nextTick(() => {
      this.positionHotspots();
    });
  }
}
</script>
